export default __webpack_public_path__ + "static/media/pied.bf14cb84.jpg";